import { ThumbnailRenderer } from "@app/components/Dashboard/DashboardTable/renderers/ThumbnailRenderer";
import { ColumnDef } from "@tanstack/react-table";
import { CellRenderer } from "@app/components/Dashboard/DashboardTable/renderers/CellRenderer";
import { CellContext } from "@tanstack/react-table";

export interface PostingReport {
  account_id: string;
  story_id: string;
  name: string;
  date: string;
  time: string;
  completion_rate: number;
  view_started_count: number;
  viewed_count: number;
  skipped_count: number;
  viewed_duration: number;
  product_clicked_count: number;
  is_deleted: boolean;
  group_names: string[];
}

const renderCell =
  (valueType: string = "string") =>
  (row: CellContext<PostingReport, any>) => (
    <CellRenderer valueType={valueType} context={row} />
  );
const renderThumbnail = (row: CellContext<PostingReport, any>) => (
  <ThumbnailRenderer context={row} />
);

export const postingReportColumns: ColumnDef<PostingReport, any>[] = [
  {
    id: "thumbnail",
    header: "포스팅",
    accessorKey: "thumbnail",
    minSize: 80,
    maxSize: 80,
    cell: renderThumbnail,
    enableSorting: false,
    enableResizing: false,
  },
  {
    id: "storyName",
    header: "포스팅명",
    accessorKey: "name",
    cell: renderCell("string"),
    minSize: 80,
    size: 200,
    accessorFn: (data) => {
      return data.name + `${data.is_deleted ? " (삭제)" : ""}`;
    },
  },
  {
    id: "groupNames",
    header: "그룹명",
    accessorKey: "group_names",
    cell: renderCell("string"),
    minSize: 80,
    size: 200,
    accessorFn: (data) => {
      return data.group_names.join(" , ");
    },
  },
  {
    id: "viewedCount",
    header: "조회수",
    accessorKey: "view_started_count",
    cell: renderCell("number"),
    minSize: 80,
    size: 100,
  },
  {
    id: "completionRate",
    header: "시청완료율",
    accessorKey: "completion_rate",
    cell: renderCell("percentage"),
    accessorFn: (data) => data.viewed_count / data.view_started_count,
    minSize: 100,
    size: 120,
  },
  {
    id: "productClickedCount",
    header: "상품클릭수",
    accessorKey: "product_clicked_count",
    cell: renderCell("number"),
    minSize: 100,
    size: 120,
  },
  {
    id: "productClickedRatio",
    header: "클릭율",
    accessorKey: "product_clicked_count",
    cell: renderCell("percentage"),
    accessorFn: (data) => data.product_clicked_count / data.view_started_count,
    minSize: 100,
    size: 120,
  },
  {
    id: "viewedDuration",
    header: "총 시청시간",
    accessorKey: "viewed_duration",
    cell: renderCell("time"),
    minSize: 100,
    size: 170,
  },
  {
    id: "avgViewedDuration",
    header: "평균 시청시간",
    accessorKey: "avg_viewed_duration",
    cell: renderCell("time"),
    minSize: 100,
    size: 170,
  },
  // { id: 'date', header: '날짜', accessorKey: 'date' },
  // { id: 'duration', header: '시간', accessorKey: 'duration' },
  // { id: 'totalDuration', header: '시간', accessorKey: 'totalDuration' },
];

export interface PostingGroupReport {
  id: string;
  name: string;
  date: string;
  time: string;
  completion_rate: number;
  view_started_count: number;
  viewed_count: number;
  skipped_count: number;
  viewed_duration: number;
  product_clicked_count: number;
  is_deleted: boolean;
}

const renderPostingGroupCell =
  (valueType: string = "string") =>
  (row: CellContext<PostingGroupReport, any>) => (
    <CellRenderer valueType={valueType} context={row} />
  );

export const postingGroupReportColumns: ColumnDef<PostingGroupReport, any>[] = [
  {
    id: "groupName",
    header: "그룹명",
    accessorKey: "name",
    cell: renderPostingGroupCell("string"),
    minSize: 80,
    size: 200,
    accessorFn: (data) => {
      return data.name + `${data.is_deleted ? " (삭제)" : ""}`;
    },
  },
  {
    id: "viewedCount",
    header: "조회수",
    accessorKey: "view_started_count",
    cell: renderPostingGroupCell("number"),
    minSize: 80,
    size: 100,
  },
  {
    id: "completionRate",
    header: "시청완료율",
    accessorKey: "completion_rate",
    cell: renderPostingGroupCell("percentage"),
    accessorFn: (data) => data.viewed_count / data.view_started_count,
    minSize: 100,
    size: 120,
  },
  {
    id: "productClickedCount",
    header: "상품클릭수",
    accessorKey: "product_clicked_count",
    cell: renderPostingGroupCell("number"),
    minSize: 100,
    size: 120,
  },
  {
    id: "productClickedRatio",
    header: "클릭율",
    accessorKey: "product_clicked_count",
    cell: renderPostingGroupCell("percentage"),
    accessorFn: (data) => data.product_clicked_count / data.view_started_count,
    minSize: 100,
    size: 120,
  },
  {
    id: "viewedDuration",
    header: "총 시청시간",
    accessorKey: "viewed_duration",
    cell: renderPostingGroupCell("time"),
    minSize: 100,
    size: 170,
  },
  {
    id: "avgViewedDuration",
    header: "평균 시청시간",
    accessorKey: "avg_viewed_duration",
    cell: renderPostingGroupCell("time"),
    minSize: 100,
    size: 170,
  },
  // { id: 'date', header: '날짜', accessorKey: 'date' },
  // { id: 'duration', header: '시간', accessorKey: 'duration' },
  // { id: 'totalDuration', header: '시간', accessorKey: 'totalDuration' },
];
